import { Image } from "goi_common";

export interface CdnImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
  id?: string;
}

export function CdnImage({ src, alt, width, height, className, onClick, id }: CdnImageProps) {
  return (
    <Image
      className={className}
      src={`${process.env.NEXT_PUBLIC_CDN_URL}${src}`}
      alt={alt}
      width={width && `${width}px`}
      height={width && `${height}px`}
      onClick={onClick}
      id={id}
    />
  );
}
